@if (config.tooltip) {
  <div class="tooltip-section">
    <label>{{config.labelTooltip}}</label>
    <mat-icon
      matTooltip="Orientação de preenchimento: {{config.tooltipText}}" [matTooltipPosition]="'above'">
      help_outline
    </mat-icon>
  </div>
}
<mat-form-field
  appearance="outline"
  [formGroup]="formGroup"
  style="margin-bottom: -1.25em; width: 100%;"
  >
  <mat-label>{{config.label}}</mat-label>

  @if (config.inputTipo !== 'textarea') {
    <input
      #input
      matInput
      [required]="requerido"
      [placeholder]="config.placeholder || ''"
      [formControl]="controle"
      [type]="config.inputTipo === 'password' ? esconderSenha ? 'password' : 'text' : config.inputTipo || ''"
      maxlength="{{config.tamanhoMaximo ? config.tamanhoMaximo : undefined }}"
      minlength="{{config.tamanhoMinimo ? config.tamanhoMinimo : undefined }}"
           [ngClass]="{
      upercase : config.todasMaiusculas
    }"
      min="{{config.rangeMinimo ? config.rangeMinimo : undefined }}"
      max="{{config.rangeMaximo ? config.rangeMaximo : undefined }}"
      step="{{config.step ? config.step : 1 }}"
      [mask]="config.mascara || ''"
      [dropSpecialCharacters]="config.removerCaracteresMascara || false"
      [readonly]="config.readonly"
      />
  } @else {
    @if (config.inputTipo == 'textarea') {
      <textarea  #input
        matInput
        [required]="requerido"
        [placeholder]="config.placeholder || ''"
        [formControl]="controle"
        [type]="config.inputTipo"
        maxlength="{{config.tamanhoMaximo ? config.tamanhoMaximo  : undefined }}"
        minlength="{{config.tamanhoMinimo ? config.tamanhoMinimo  : undefined }}"
             [ngClass]="{
    upercase : config.todasMaiusculas}"
        [readonly]="config.readonly"
      [rows]="config.linhas"></textarea>
    }
  }
  @if (config.inputTipo === 'password') {
    <mat-icon  matSuffix (click)="esconderSenha = !esconderSenha">{{esconderSenha ? 'visibility_off' : 'visibility'}}</mat-icon>
  }
  @if (config.sufixoIcone) {
    <mat-icon matSuffix
      >{{config.sufixoIcone}}</mat-icon
      >
    }
    @if (config.prefixoIcone) {
      <mat-icon matPrefix
        >{{config.prefixoIcone}}</mat-icon
        >
      }
    </mat-form-field>
